import { Button } from '@tabeo/scarf2'
import Navbar from 'components/Navbar'
import { Link } from 'react-router'
import { twMerge } from 'tailwind-merge'

function Box({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={twMerge(
        'mx-auto w-full rounded bg-white px-3 py-5 desktop:max-w-[504px] desktop:border desktop:border-tabeo-sky-1 desktop:px-12 desktop:py-12 desktop:shadow-tabeo-md',
        className
      )}
    >
      {children}
    </div>
  )
}

export default function PasswordChanged() {
  const url = new URL(window.location.href)
  const emailFromUrl = url.searchParams.get('email') || ''
  return (
    <div className="flex flex-col from-tabeo-primary-6 to-tabeo-sky-3 desktop:min-h-screen desktop:bg-linear-to-br">
      <Navbar />
      <div className="flex-1 px-4 pb-8 pt-16 desktop:px-0 desktop:pb-16 desktop:pt-32">
        <Box>
          <h1 className="title mb-2">Password updated</h1>
          <p>
            You&apos;ve successfully updated your password. For security
            reasons, you&apos;ve been signed out.
          </p>
          <Button
            variant="primary"
            className="mt-6 w-full"
            as={Link}
            to={`/login?email=${encodeURIComponent(emailFromUrl)}`}
          >
            Sign in
          </Button>
        </Box>
      </div>
    </div>
  )
}
